<div class="fixed flex p-3 w-full" style="left: 280px; top: 50px">
  <div style="background-color: yellow; width: calc(100% - 280px)">stage <router-outlet /></div>
</div>
